'use client'

import type { GroundData } from '@/app/_components/ground/load-ground-data'
import { SpecimenFrame } from '@/app/_components/ground/specimen-frame'
import { GlyphAnchor, MeaningHeadline } from '@/components/practice'
import { AdvanceAffordance } from '@/learn/kanji/[frame]/_components/advance-affordance'
import { MarginaliaTop } from '@/learn/kanji/[frame]/_components/marginalia-top'
import { StoryProse } from '@/learn/kanji/[frame]/_components/story-prose'
import { StrokeAffordance } from '@/learn/kanji/[frame]/_components/stroke-affordance'

// Beat 01: the Learn study screen for frame 01, every row revealed, in the
// order LearnFrame reveals them (marginalia, glyph, meaning, story,
// strokes, the "Draw it →" affordance). LearnFrame itself reveals rows
// from internal state and cannot be rendered revealed, so the rows are
// composed here from the same leaves.
export function StudySpecimen({
    data,
}: {
    data: Pick<GroundData, 'lesson' | 'one' | 'oneStory' | 'oneStrokes'>
}) {
    const k = data.one
    return (
        <SpecimenFrame beat={1}>
            <MarginaliaTop
                lessonNumber={data.lesson.number}
                frame={Number(k.frameNumber)}
            />
            {/* The beat's focus is the glyph with its keyword and story:
                what "Read the story." must show above the sheet's lip at
                rest (spec §3, §4). On short viewports the camera pans the
                frame label under the rail to fit it. */}
            <div className="mt-6 flex flex-col md:mt-8" data-focus>
                <GlyphAnchor character={k.character} />
                <div className="mt-8 flex flex-col gap-8 md:mt-10">
                    <MeaningHeadline meaning={k.meaning} />
                    {data.oneStory ? (
                        <div data-story>
                            <StoryProse keywordBody={data.oneStory} />
                        </div>
                    ) : null}
                </div>
            </div>
            <div className="mt-8 flex flex-1 flex-col">
                <StrokeAffordance
                    character={k.character}
                    strokeCount={k.strokeCount}
                    revealStages={k.revealStages}
                    gradeSlice={k.gradeSlice}
                    strokeData={data.oneStrokes}
                    strokeHost={k.strokeHost}
                />
            </div>
            <AdvanceAffordance kind="link" href="#" label="Draw it →" />
        </SpecimenFrame>
    )
}
